import React from 'react'
import '../styles/footer.css'

const Footer = ({ isLanding, lang }) => {
  const documents = [
    {
      filepath: lang.docFilePath.pds_single,
      label: lang.footer.pds,
    },
    {
      filepath: lang.docFilePath.pw_single,
      label: lang.footer.pwt,
    },
    {
      filepath: lang.docFilePath.pds_annual,
      label: lang.footer.pdsAnnual,
    },
    {
      filepath: lang.docFilePath.pw_annual,
      label: lang.footer.pwtAnnual,
    },
  ]
  return (
    <div>
      <footer>
        <div className="key_download-container">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <h5>{lang.footer.onlineProduct}</h5>
                <ul>
                  <li>
                    <a
                      href={lang.productLinks.secureHome}
                      target="_blank"
                    >
                      Secure Home
                    </a>
                  </li>
                  <li>
                    <a
                      href={lang.productLinks.snatchMedz}
                      target="_blank"
                    >
                      Snatch Medz+
                    </a>
                  </li>
                  <li>
                    <a
                      href={lang.productLinks.snatchShield}
                      target="_blank"
                    >
                      Snatch Shield Plus
                    </a>
                  </li>
                  <li>
                    <a href={lang.productLinks.secureMotor} target="_blank">
                      Secure Motor
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <h5>{lang.footer.keyDownload}</h5>
                <ul>
                  {/* PDS & PW */}
                  {documents
                    .map((doc, index) => (
                      <li key={index}>
                        <a href={doc.filepath} target="_blank">
                          {doc.label}
                        </a>
                      </li>
                    ))}

                  {/* English Brochure  */}
                  {/* {lang.id == 'EN' && (
                    <li>
                      <a
                        href="/securetravel/docs/SOMPO TravelSafe eBrochure (ENG) 1 March 2024.pdf"
                        target="_blank"
                      >
                        {lang.footer.eBrochure}
                      </a>
                    </li>
                  )} */}

                  {/* BM Brochure  */}
                  {/* {lang.id == 'BM' && (
                    <li>
                      <a
                        href="/securetravel/docs/SOMPO TravelSafe eBrochure (BM) 1 March 2024.pdf"
                        target="_blank"
                      >
                        {lang.footer.eBrochure}
                      </a>
                    </li>
                  )} */}

                  <li>
                    <a
                      href="https://online.berjayasompo.com.my/travel-nomination-web-form/"
                      target="_blank"
                    >
                      {lang.footer.webForm}
                    </a>
                  </li>
                  {/*
							<li><a href="highlights/faq.html" target="_blank">FAQ</a></li>
							<li><a href="resources2/template/Beneficiary Nomination.pdf" target="_blank">Beneficiary Nomination Form</a></li>
							*/}
                </ul>
              </div>
              {/* <div className="col-md-4">
						<h5>CONTACT US</h5>
						<div className="icon">
							<i className="fa fa-phone" aria-hidden="true"></i>
						</div>
						<div className="text">
							<ul>
								<li className="bold">Customer Service</li>
								<li>8:30 AM - 5:00 PM (Monday to Friday)</li>
								<li>1 800 889 933 (within Malaysia)</li>
								<li>+603 2170 7300 (overseas)</li>
								<li>24/7 Worldwide Assistance </li>
								<li>+603 7628 3860 / +603 7841 5770</li>
							</ul>
						</div>
					</div> */}
              <div className="col-md-4">
                <h5>{lang.footer.contactUs}</h5>
                {/* <div className="icon">
					<i className="fa fa-map-marker" aria-hidden="true"></i>
				</div> */}
                <div className="text">
                  <ul>
                    <li className="bold">{lang.footer.address}</li>
                    {/* <li className="bold">Berjaya Sompo Insurance Berhad
							Registration No: 198001008821 (62605-U)</li> */}
                    <li>Level 36, Menara Bangkok Bank, 105, Jalan Ampang, 50450 Kuala Lumpur</li>
                  </ul>
                </div>
                <div className="text mt-3">
                  <ul>
                    <li className="bold">{lang.footer.cs}</li>
                    <li>{lang.footer.time}</li>
                    <li>{lang.footer.tel1}</li>
                    <li>{lang.footer.tel2}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="social-media_container">
          <div className="container">
            <div className="row social-media">
              <div className="col-md-6 col-6 multi_lang">
                {isLanding ? (
                  <>
                    <nav className="navbar navbar-expand-lg ">
                      <ul className="navbar-nav">
                        <li class="nav-item dropdown ml-auto">
                          <a
                            class="multi_lang_nav nav-link dropdown-toggle bold online-menu_pad2"
                            href="#"
                            id="navbarDropdownPortfolio"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {lang.id === 'EN' ? `English` : `Bahasa`}
                          </a>
                          <div
                            class="dropdown-menu dropdown-menu-right multi_lang-dropdown"
                            aria-labelledby="navbarDropdownPortfolio"
                          >
                            <a
                              class="dropdown-item"
                              href="https://online.berjayasompo.com.my/cimb/securetravel/insurans-perjalanan/"
                              hidden={lang.id === 'BM' ? true : false}
                            >
                              Bahasa
                            </a>
                            <a
                              class="dropdown-item"
                              href="https://online.berjayasompo.com.my/cimb/securetravel/"
                              hidden={lang.id === 'EN' ? true : false}
                            >
                              English
                            </a>
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </>
                ) : (
                  ''
                )}
              </div>
              <div className="col-lg-6 col-md-6 col-6">
                <ul>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/SOMPOonline/"
                      rel="noreferrer"
                    >
                      <img src={'/securetravel/images/ico-fb.svg'} alt="Facebook" />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.instagram.com/berjayasompoinsurance/"
                      rel="noreferrer"
                    >
                      <img src={'/securetravel/images/ico-instagram.svg'} alt="Instagram" />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.youtube.com/channel/UC4nnYK4l_h1LmK6m-JMelYg"
                      rel="noreferrer"
                    >
                      <img src={'/securetravel/images/ico-utube.svg'} alt="Youtube" />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/berjaya-sompo-insurance-berhad"
                      rel="noreferrer"
                    >
                      <img src={'/securetravel/images/ico-linkedin.svg'} alt="Linkedin" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-footer_container justify-content-center d-flex">
          <div className="container d-lg-inline-flex d-md-block">
            <div className="row col-md-12 col-lg-10 bottom-footer">
              <div className="col-md-7">
                <ul className="text-center text-md-left">
                  <li>
                    <a
                      target="_blank"
                      href="https://www.berjayasompo.com.my/terms-conditions"
                    >
                      General Policy Terms &amp; Conditions
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.berjayasompo.com.my/privacy-notice">
                      Privacy Notice
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.berjayasompo.com.my/legal-notice">
                      Legal Notice
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://www.berjayasompo.com.my/disclaimer">
                      Disclaimer
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.berjayasompo.com.my/whistle-blowing-policy"
                    >
                      Whistle Blowing Policy
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.berjayasompo.com.my/customer-service-charter#pillar-1-insurance-made-accessible"
                    >
                      Customer Service Charter
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                    >
                      {lang.id === 'EN' ? ' PIDM TIPS Brochure' : 'Brosur PIDM'}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-5 copy text-center text-md-right">
                <div className="d-inline-block">
                  Copyright © {new Date().getFullYear()} Berjaya Sompo Insurance Berhad <br /> Registration No:
                  198001008821 (62605-U)
                </div>
              </div>
              <div class="pidm-disclosure col-md-12 pl-0">
                {lang.id === 'EN' ? (
                  <>
                    <div className="col-md-10 d-inline-block text-center text-md-left">
                      The benefit(s) payable under eligible product is protected by PIDM up to
                      limits. Please refer to
                      <a
                        href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                        target="_blank"
                      >
                        {' '}
                        PIDM's TIPS Brochure{' '}
                      </a>{' '}
                      or contact Berjaya Sompo Insurance Berhad or PIDM (visit{' '}
                      <a href="https://www.pidm.gov.my" target="_blank">
                        www.pidm.gov.my
                      </a>
                      ).
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-10 d-inline-block text-center text-md-left">
                      Manfaat-manfaat yang dibayar di bawah sijil/polisi/produk yang layak adalah
                      dilindungi oleh PIDM sehingga had perlindungan. Sila rujuk
                      <a
                        href="https://www.pidm.gov.my/pidm2022/files/92/92bdfcde-3534-4a29-9031-5186387623ee.pdf"
                        target="_blank"
                      >
                        {' '}
                        Brosur Sistem Perlindungan Manfaat Takaful dan Insurans PIDM{' '}
                      </a>{' '}
                      atau hubungi Berjaya Sompo Insurance Berhad atau PIDM (layari{' '}
                      <a href="https://www.pidm.gov.my" target="_blank">
                        www.pidm.gov.my
                      </a>
                      ).
                    </div>
                  </>
                )}
                <br /><br />
                <div className="col-md-10 d-inline-block text-center text-md-left">
                  {lang.footer.bnm_warning}
                </div>
              </div>
            </div>
            <div className="d-inline-flex justify-content-center p-4 col-md-12 col-lg-2">
              <a class="footer-minilogo" href="https://www.pidm.gov.my/my" target="_blank">
                <img src="/securetravel/images/footlogo-bigpidm.jpg" alt="PIDM" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer
